import React from 'react';
import { FaFacebook, FaTwitter, FaYoutube, FaInstagram } from 'react-icons/fa'; // Importing icons

const Footer = () => {
    return (
        <footer className="bg-dark text-white pt-5 pb-3">
            <div className="container">
                <div className="row">
                    {/* Contact Information Section */}
                    <div className="col-md-3">
                        <h5>Contact Information</h5>

                        <p>At Shanti Fertilizer, we are committed to revolutionizing agriculture by providing high-quality fertilizers that enhance soil fertility and increase crop yield. </p>
                    </div>

                    {/* Quick Links Section */}
                    <div className="col-md-3">
                        <h5>Quick Links</h5>
                        <ul className="list-unstyled">
                            <li><a href="/home" className="text-white">Home</a></li>
                            <li><a href="/about" className="text-white">About Us</a></li>
                            <li><a href="/services" className="text-white">Services</a></li>
                            <li><a href="/contact" className="text-white">Contact</a></li>
                        </ul>
                    </div>

                    {/* Services Section */}
                    <div className="col-md-3">
                        <h5>Our Services</h5>
                        <ul className="list-unstyled">
                            <li><a href="/" className="text-white">Our Products</a></li>
                            <li><a href="/" className="text-white">Other products</a></li>
                            <li><a href="/" className="text-white">About Company</a></li>
                            <li><a href="/" className="text-white">About Chairman</a></li>
                        </ul>
                    </div>

                    {/* Social Media Section */}
                    <div className="col-md-3">
                        <h5>Follow Us</h5>
                        <div className='socials'>
                            <a href="#" target="_blank" rel="noopener noreferrer" className="text-white mr-3">
                                <FaFacebook size={20} />
                            </a>

                            <a href="#" target="_blank" rel="noopener noreferrer" className="text-white mr-3">
                                <FaYoutube size={20} />
                            </a>
                            <a href="#" target="_blank" rel="noopener noreferrer" className="text-white">
                                <FaInstagram size={20} />
                            </a>


                            <a href="#" target="_blank" rel="noopener noreferrer" className="text-white mr-3">
                                <FaTwitter size={20} />
                            </a>

                            <ul className="list-unstyled">
                                <li><strong> Address:</strong> Akansha Nursing-Home Ram Sanehi Ghat, Barabanki 225409 </li>
                                <li> <strong>Email:</strong> fertilizers.shanti@gmail.com</li>
                                <li> <strong>Phone:</strong> +91 9477777444</li>

                            </ul>


                        </div>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="row pt-4 mt-4 border-top">
                    <div className="col text-center">
                        <p>&copy; 2025 SHANTI FERTILIZER
                        | All rights reserved Powered By Creative Digital World</p>
                    </div>
                </div>


                <a href="https://wa.me/+919477777444" className="whatsapp-button" target="_blank">
                    <i className="fa fa-whatsapp"></i>
                </a>

            </div>
        </footer>
    );
}

export default Footer;
